import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { AuthProvider } from "@/contexts/auth";
import { ProtectedRoute } from "@/components/protected-route";
import { AdminProtectedRoute } from "@/components/admin-protected-route";
import NotFound from "@/pages/not-found";
import Home from "@/pages/home";
import Submit from "@/pages/submit";
import Login from "@/pages/login";
import Dashboard from "@/pages/dashboard";

function Router() {
  return (
    <Switch>
      <Route path="/login" component={Login} />
      <Route path="/submit" component={Submit} />
      <AdminProtectedRoute path="/dashboard" component={Dashboard} />
      <Route path="/">
        <ProtectedRoute>
          <Home />
        </ProtectedRoute>
      </Route>
      <Route component={NotFound} />
    </Switch>
  );
}

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <div className="min-h-screen bg-gradient-to-br from-[#5a8ba7]/10 to-[#4b4f54]/10 flex flex-col">
          <div className="flex-grow">
            <Router />
            <Toaster />
          </div>
          <footer className="text-center px-4 pt-12 pb-8 bg-transparent text-gray-600 text-sm mt-auto">
            © 2025, Unbridled Solutions., L.L.C. DBA Unbridled |{' '}
            <a
              href="https://www.unbridled.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              Privacy Policy
            </a>
          </footer>
        </div>
      </AuthProvider>
    </QueryClientProvider>
  );
}